import { IsVisibleOnFilterBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnFilterBase';
export class IsVisibleOnFilterValueConverter extends IsVisibleOnFilterBaseValueConverter {

}